import { ActionPlugin } from '../Action/plugin'
import { ActionCallElementNode } from './TypedNode'

import type { RehajePlugin } from '@rehaje/core'

export class ActionCallElementPlugin implements RehajePlugin {
  constructor() {
    return new ActionPlugin({
      actions: {
        CallElement: ActionCallElementNode
      }
    })
  }
}
